<template>
    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="18.228" height="15.885" viewBox="0 0 18.228 15.885">
        <defs>
            <clipPath id="clip-path">
            <rect id="Retângulo_1153" data-name="Retângulo 1153" width="18.228" height="15.885" fill="#498e16" stroke="#0771c5" stroke-width="1"/>
            </clipPath>
        </defs>
        <g id="Grupo_11871" data-name="Grupo 11871" clip-path="url(#clip-path)">
            <path id="Caminho_10512" data-name="Caminho 10512" d="M9.145,0C4.094,0,0,3.326,0,7.431A6.6,6.6,0,0,0,2.036,12.1,9.088,9.088,0,0,1,.079,15.522a.284.284,0,0,0-.054.311A.28.28,0,0,0,.286,16a8.17,8.17,0,0,0,5.023-1.836,10.9,10.9,0,0,0,3.837.693c5.051,0,9.145-3.326,9.145-7.431S14.2,0,9.145,0" transform="translate(0 -0.107)" fill="#0771c5" stroke="#0771c5" stroke-width="1"/>
        </g>
    </svg>
</template>
